/* HTML教材の「現在の見出し」バーと見出し一覧パネル。
 * 無限スクロールで記事が増えるため、現在の記事と見出しは毎回DOMから取り直す。
 */
(function () {
  "use strict";

  var ROOT_SEL = "[data-html-article]";
  var ENTRY_SEL = "[data-hta-entry]";
  var HEADING_SEL = ".html-article__body h2, .html-article__body h3";
  var READ_LINE = 96;

  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var bar = root.querySelector("[data-hta-toc]");
  var barText = root.querySelector("[data-hta-toc-text]");
  var panel = root.querySelector("[data-hta-toc-panel]");
  var overlay = root.querySelector("[data-hta-toc-overlay]");
  var list = root.querySelector("[data-hta-toc-list]");
  var button = root.querySelector("[data-hta-toc-button]");
  var closeButton = root.querySelector("[data-hta-toc-close]");
  if (!bar || !barText || !panel || !overlay || !list || !button || !closeButton) return;

  var headingSeq = 0;
  var currentEntry = null;
  var currentHeading = null;
  var headings = [];
  var lastFocus = null;
  var savedOverflow = "";

  function ensureId(heading) {
    if (!heading.id) {
      headingSeq += 1;
      heading.id = "hta-h-" + headingSeq;
    }
    return heading.id;
  }

  function text(node) {
    return (node.textContent || "").replace(/\s+/g, " ").trim();
  }

  function activeEntry() {
    var all = Array.prototype.slice.call(root.querySelectorAll(ENTRY_SEL));
    if (!all.length) return null;
    var found = null;
    all.forEach(function (entry) {
      var box = entry.getBoundingClientRect();
      if (box.top <= READ_LINE && box.bottom > READ_LINE) found = entry;
    });
    return found || (all[0].getBoundingClientRect().top > READ_LINE ? all[0] : all[all.length - 1]);
  }

  function collect(entry) {
    return Array.prototype.slice.call(entry.querySelectorAll(HEADING_SEL))
      .filter(function (heading) { return text(heading) !== ""; });
  }

  function buildList() {
    list.textContent = "";
    headings.forEach(function (heading) {
      var item = document.createElement("li");
      item.className = "hta-toc__item";
      if (heading.tagName.toLowerCase() === "h3") item.className += " hta-toc__item--sub";
      item.setAttribute("data-target", ensureId(heading));

      var hit = document.createElement("button");
      hit.type = "button";
      hit.textContent = text(heading);
      item.appendChild(hit);
      list.appendChild(item);
    });
  }

  function markCurrent() {
    var id = currentHeading ? currentHeading.id : "";
    Array.prototype.forEach.call(list.children, function (item) {
      item.classList.toggle("hta-toc__item--current", item.getAttribute("data-target") === id);
    });
  }

  function open() {
    markCurrent();
    lastFocus = document.activeElement;
    savedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    panel.hidden = false;
    overlay.hidden = false;
    button.setAttribute("aria-expanded", "true");
    closeButton.focus();
  }

  function close(returnFocus) {
    if (panel.hidden) return;
    panel.hidden = true;
    overlay.hidden = true;
    button.setAttribute("aria-expanded", "false");
    document.documentElement.style.overflow = savedOverflow;
    if (returnFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  button.addEventListener("click", function () {
    if (panel.hidden) open(); else close(true);
  });
  overlay.addEventListener("click", function () { close(true); });
  closeButton.addEventListener("click", function () { close(true); });
  document.addEventListener("keydown", function (event) {
    if (panel.hidden) return;
    if (event.key === "Escape") { close(true); return; }
    if (event.key !== "Tab") return;
    var focusable = Array.prototype.slice.call(panel.querySelectorAll(
      'button:not([hidden]):not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (node) { return node.getClientRects().length > 0; });
    if (!focusable.length) { event.preventDefault(); closeButton.focus(); return; }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });

  list.addEventListener("click", function (event) {
    var item = event.target.closest(".hta-toc__item");
    if (!item) return;
    var target = document.getElementById(item.getAttribute("data-target"));
    close(false);
    if (!target) return;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - READ_LINE + 8,
      behavior: window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    });
    target.setAttribute("tabindex", "-1");
    target.focus({ preventScroll: true });
  });

  function update() {
    var entry = activeEntry();
    if (!entry) return;

    if (entry !== currentEntry) {
      currentEntry = entry;
      headings = collect(entry);
      currentHeading = null;
      buildList();
      bar.hidden = headings.length === 0;
      if (bar.hidden) { close(true); return; }
    }
    if (!headings.length) return;

    var found = headings[0];
    headings.forEach(function (heading) {
      if (heading.getBoundingClientRect().top <= READ_LINE) found = heading;
    });
    if (found !== currentHeading) {
      currentHeading = found;
      barText.textContent = text(found);
      if (!panel.hidden) markCurrent();
    }
  }

  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; update(); });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  var main = root.querySelector(".html-article__main") || root;
  new MutationObserver(onScroll).observe(main, { childList: true });
  update();
  window.addEventListener("load", update);
})();
